<template>
  <section class="section">
    <!-- Header -->
    <nav
      class="level"
      style="margin-bottom: 4%; margin-top: 2%"
      v-if="participation"
    >
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Lideres</p>
          <p class="title">{{ participation.countLeaders }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Encuestas terminadas</p>
          <p class="title">{{ participation.countFinished }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Total encuestas</p>
          <p class="title">{{ participation.countTotal }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Participación Actual</p>
          <p class="title">
            {{
              !isNaN(participation.percentageCompany)
                ? participation.percentageCompany
                : 0
            }}
            %
          </p>
        </div>
      </div>
    </nav>

    <!-- Table -->
    <table-ag
      v-if="relations && Object.keys(tokenUser).length"
      :rowData="relations"
      :columnDefs="columns"
      :component-menu="componentMenu"
      :actions="true"
    ></table-ag>

    <!-- Modal's -->
    <modalemployee
      :show="statusModalEmployee"
      :proceso="proceso"
      @showModalEmployee="showModalEmployee"
      @evaluatedEmployee="evaluatedEmployee"
      @evaluatorEmployee="evaluatorEmployee"
      @createRelation="createRelation"
    ></modalemployee>
  </section>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
import tableAg from "../dashboard/tableAg.vue";
import menuTable from "./components/menuTable.vue";
import modalemployee from "../modals/ModalCreateRelacion";
const XLSX = require("xlsx");

export default {
  data() {
    return {
      columns: [
        {
          field: "evaluado",
          headerName: "Evaluado",
          autoHeight: true,
          valueGetter: (params) => {
            return `${params.data[params.colDef.field].nombre} ${
              params.data[params.colDef.field].email
            }`;
          },
          getQuickFilterText: (params) => {
            return `${params.data[params.colDef.field].nombre} ${
              params.data[params.colDef.field].email
            }`;
          },
          cellRenderer: (params) => {
            return `<div style='font-size: 1.25rem; font-weight: 550; color: #363636; line-height: 1.125; overflow: hidden; text-overflow: ellipsis; padding-top: 10px'>${
              params.data[params.colDef.field].nombre
            }</div><div style='font-size: 1rem; font-weight: 300; color: #4a4a4a; line-height: 1.25; overflow: hidden; text-overflow: ellipsis; padding-bottom: 10px'>${
              params.data[params.colDef.field].email
            }</div>`;
          },
          editable: false,
        },
        {
          field: "relacion",
          headerName: "Relación",
          width: 150,
          cellRenderer: (params) => {
            return this.formatRelations(params.value);
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          editable: false,
        },
        {
          field: "evaluador",
          headerName: "Evaluador",
          autoHeight: true,
          valueGetter: (params) => {
            return `${params.data[params.colDef.field].nombre} ${
              params.data[params.colDef.field].email
            }`;
          },
          getQuickFilterText: (params) => {
            return `${params.data[params.colDef.field].nombre} ${
              params.data[params.colDef.field].email
            }`;
          },
          cellRenderer: (params) => {
            return `<div style='font-size: 1.25rem; font-weight: 550; color: #363636; line-height: 1.125; overflow: hidden; text-overflow: ellipsis; padding-top: 10px'>${
              params.data[params.colDef.field].nombre
            }</div><div style='font-size: 1rem; font-weight: 300; color: #4a4a4a; line-height: 1.25; overflow: hidden; text-overflow: ellipsis; padding-bottom: 10px'>${
              params.data[params.colDef.field].email
            }</div>`;
          },
          editable: false,
        },
        {
          field: "status",
          headerName: "Estado",
          width: 90,
          cellRenderer: (params) => {
            return this.formatStatus(params);
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          editable: false,
        },
        {
          field: "_id",
          headerName: "Controles",
          colId: "_actions",
          editable: false,
          cellRenderer: "buttonsActionRelation",
          cellRendererParams: {
            widthCols: this.widthCols,
            getRelations: this.getRelations,
          },
          hide: this.tokenUser.ghumana,
          sortable: false,
          width: 150,
        },
      ],
      relations: [],
      participation: null,
      customCellRenderers: {},
      componentMenu: () => {
        return {
          render: (h) =>
            h(menuTable, {
              props: {
                proceso: this.proceso,
                widthCols: this.widthCols,
              },
              on: {
                excelEarrings: this.excelEarrings,
                sendAllEmailsPending: this.sendAllEmailsPending,
                showModalEmployee: this.showModalEmployee,
                getRelations: this.getRelations,
                getParticipation: this.getParticipation,
              },
            }),
        };
      },
      statusModalEmployee: false,
      relation: {
        evaluado: {},
        evaluador: [],
        relacion: "",
      },
    };
  },
  props: {
    proceso: {
      type: Object,
    },
    tokenUser: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["idtoken"]),
  },
  beforeMount() {
    this.$emit("calculateProcess");
  },
  methods: {
    // Table
    async getRelations() {
      let result;
      try {
        result = await apiServices.get(
          `/listliderrelacion/${this.proceso._id}`
        );
        if (result.data) {
          this.relations = result.data;
        }
      } catch (err) {
        await this.$store.dispatch("notify", {
          message: "Error al obtener las relaciones.",
          type: "is-danger",
          duration: 4000,
          position: "top-right",
        });
        console.log(err);
      }
    },
    async getParticipation() {
      try {
        this.procesoId = this.proceso._id;
        let result = await apiServices.post(`/participation`, {
          id: this.procesoId,
        });
        this.participation = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Excel
    async excelInfo(datos) {
      let data = [];
      try {
        for (let i = 0; i < datos.length; i++) {
          let d = datos[i];
          let user;

          if (d.status !== "calculado") {
            user = {
              Evaluado: d.evaluado.nombre,
              "Correo de Evaluado": d.evaluado.email,
              Evaluador: d.evaluador.nombre,
              "Correo de Evaluador": d.evaluador.email,
              Estado: d.status,
            };

            data.push(user);
          }
        }
        return {
          data: [data],
          names: ["Usuarios sin Calcular"],
        };
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    async excelEarrings() {
      try {
        let data = await this.excelInfo(this.relations);

        if (data.data.length > 0) {
          //  Recorremos las diferentes datas creando un Excel para cada uno
          for (let i = 0; i < data.data.length; i++) {
            //  Asignamos la información necesaria a nuevas variables
            let dataExc = data.data[i];
            let name = data.names[i];
            //  Se agrega la data al libro de excel
            const ws = XLSX.utils.json_to_sheet(dataExc);

            //  Se configura el tamaño de cada columna
            ws["!cols"] = this.widthCols(dataExc);

            //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Hoja1");
            const nombreArchivo = name + ".xlsx";
            XLSX.writeFile(wb, nombreArchivo);
          }
        } else {
          await this.$store.dispatch("notify", {
            message: `No hay datos para descargar`,
            type: "is-link",
          });
        }
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    // Module
    async sendAllEmailsPending() {
      const config = {
        title: "¿Estás seguro?",
        text: "Enviaras un correo a todos los usuarios que están pendientes.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, eliminar",
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const result = await apiServices.post(`/enviarcorreolote`, {
              proceso: this.proceso._id,
            });
            if (result.data) {
              await this.$store.dispatch("notify", {
                message: "Correos enviados correctamente.",
              });
            }
            this.traerelaciones();
          } catch (err) {
            console.log(err);
            await this.$store.dispatch("notify", {
              message: "Error al enviar los correos.",
              type: "is-danger",
              duration: 4000,
              position: "top-right",
            });
          }
        }
      });
    },
    evaluatedEmployee(evaluatedEmployee) {
      this.relation.evaluado = evaluatedEmployee;
    },
    evaluatorEmployee(evaluatorEmployee) {
      this.relation.evaluador = evaluatorEmployee;
    },
    async createRelation() {
      let result;
      this.relation.proceso = this.proceso._id;
      try {
        result = await apiServices.post(`/createliderrelacion`, this.relation);
        if (result.data) {
          await this.$store.dispatch("notify", {
            message: "Perfecto!. Relación Creada.",
          });
          await this.getRelations();
          await this.getParticipation();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Modal
    showModalEmployee() {
      this.statusModalEmployee = !this.statusModalEmployee;
    },
    // Helpers
    formatRelations(v) {
      let r;
      if (v === "Autoevaluacion") {
        r = "Autoevaluación";
      } else if (v === "demograficos") {
        r = "Demográficos";
      } else {
        r = v;
      }
      return `<div>${r}</div>`;
    },
    formatStatus(p) {
      const v = p.value.toLowerCase();
      if (p.data.responses && !p.data.responses.agree) {
        return `<span class="tag is-info is-capitalized" style='width: 100% !important;'>Desacuerdo</span>`;
      }
      if (v === "calculado") {
        return `<span class="tag is-success is-capitalized" style='width: 100% !important;'>${v}</span>`;
      }
      if (
        p.data.responses &&
        (Object.keys(p.data.responses).length > 2 || p.data.responses.agree)
      ) {
        return `<span class="tag is-link is-capitalized" style='width: 100% !important;'>En proceso</span>`;
      }
      if (v === "terminado") {
        return `<span class="tag is-link is-capitalized" style='width: 100% !important;'>${v}</span>`;
      }
      if (v === "enviado") {
        return `<span class="tag is-warning is-capitalized" style='width: 100% !important;'>${v}</span>`;
      }
      if (v === "creado") {
        return `<span class="tag is-grey is-capitalized" style='width: 100% !important;'>${v}</span>`;
      }
    },
    widthCols(data) {
      let values = [];
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = { width: String(data[i][d]).length + 2 };
            values.push(w);
          }
          //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = String(data[i][d]).length + 2;
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = String(key).length + 2;
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values;
    },
  },
  created() {
    if (this.idtoken) {
      this.getRelations();
      this.getParticipation();
    }
  },
  watch: {
    idtoken(nv) {
      if (nv) {
        this.getRelations();
        this.getParticipation();
      }
    },
  },
  components: {
    tableAg,
    modalemployee,
  },
};
</script>

<style lang="scss">
.ag-header-cell-label {
  justify-content: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Relaciones.vue